// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"254":"ca906b05e9ee1776cf05","740":"0e11d3b995ddc36a8066"}[chunkId] + ".css";
};